//export const baseurl="https://services.dunoclub.com"
export const baseurl = import.meta.env.VITE_BASE_URL;
// Frontend app URL for share links (e.g. https://app.dunoclub.com)
export const appUrl = import.meta.env.VITE_APP_URL || (typeof window !== "undefined" ? window.location.origin : "");

/**
 * After login/signup, if the user landed via a shared skill link, redirect to the learning page (not the public skill page).
 * Returns path to navigate to and clears skill referral keys so we don't redirect again.
 * @param {string} userId - Logged-in user's id
 * @returns {string} Path to navigate to ("/" or "/learnings")
 */
export function getPostAuthRedirectPath(userId) {
  if (typeof window === "undefined" || !userId) return "/";
  const category = localStorage.getItem("duno_referral_asset_category");
  const skillId = localStorage.getItem("duno_referral_asset_id");
  if (category === "SKILL" && skillId) {
    localStorage.removeItem("duno_referral_asset_category");
    localStorage.removeItem("duno_referral_asset_id");
    return "/learnings";
  }
  return "/";
}
